'use strict';
import angular from 'angular';

angular.module('currentUser.services').factory('AdOperationsManager', ['Role', function(Role) {
    return Role.newFrozenInstance('*');
}]);